import { request, requestNative } from "@/utils/requestUtils";
import type { LoginQo, UserInfo } from "./type";

export const loginSSANativeApi = async (data: LoginQo) => {
  return requestNative<UserInfo>({
    service: "oam-admin",
    url: "/user/login",
    method: "POST",
    data,
  });
};

export async function getUserInfoApi() {
  return request<UserInfo>({
    service: "oam-admin",
    url: "/user/get_by_cookie",
    method: "POST",
  });
}

// 申请人
export async function getEmployeeList(params: any) {
  return request({
    service: "oam-admin",
    url: "/employee/query",
    method: "POST",
    data: params,
  });
}
